export type BridgePdfOutcome =
	| { kind: "none" }
	| { kind: "fixed"; pdftype: number };

const BRIDGE_PDF_TYPE = 35;

const BRIDGE_MEDS = ["bimzelx", "cosentyx", "kisqali"];

function scalarToString(value: unknown): string {
	if (value === null || value === undefined) return "";
	if (typeof value === "string") return value;
	if (
		typeof value === "number" ||
		typeof value === "boolean" ||
		typeof value === "bigint"
	) {
		return String(value);
	}
	return "";
}

/**
 * Bridge Program print routing: medication short name → member-case pdfType 35
 * (server picks bimzelx / Cosentyx / kisqali bridge assets).
 */
export function resolveBridgePdfOutcome(
	medicationShortName: unknown
): BridgePdfOutcome {
	const med = scalarToString(medicationShortName).toLowerCase();
	if (med === "") {
		return { kind: "none" };
	}
	if (BRIDGE_MEDS.some((name) => med === name || med.includes(name))) {
		return { kind: "fixed", pdftype: BRIDGE_PDF_TYPE };
	}
	return { kind: "none" };
}
